/**
 * NOTE:
 *
 * This file is automatically generated by i18n-tools.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
// Swedish
export default {
    'fabric.atlassianSwitcher.switchTo': 'Byt till',
    'fabric.atlassianSwitcher.switchToTooltip': 'Byt till…',
    'fabric.atlassianSwitcher.recent': 'Senaste',
    'fabric.atlassianSwitcher.more': 'Mer',
    'fabric.atlassianSwitcher.try': 'Prova',
    'fabric.atlassianSwitcher.manageList': 'Hantera lista',
    'fabric.atlassianSwitcher.jiraProject': 'Jira-projekt',
    'fabric.atlassianSwitcher.confluenceSpace': 'Confluence-utrymme',
    'fabric.atlassianSwitcher.people': 'Personer',
    'fabric.atlassianSwitcher.administration': 'Administration',
    'fabric.atlassianSwitcher.discoverMore': 'Upptäck mer',
    'fabric.atlassianSwitcher.errorHeading': 'Något gick fel',
    'fabric.atlassianSwitcher.errorText': 'Vi håller koll på dessa fel, men tveka inte att kontakta oss om en uppdatering inte åtgärdar problemen.',
    'fabric.atlassianSwitcher.errorImageAltText': 'En trasig robot och ett antal personer arbetar för att åtgärda felet.',
    'fabric.atlassianSwitcher.expand': 'Visa',
};
//# sourceMappingURL=sv.js.map